export const UploadFileTypes = {
  Video: "VIDEO",
  Image: "IMAGE",
  Document: "DOCUMENT",
  Conference: "CONFERENCE",
  Media: "MEDIA",
  Thumbnail: "THUMBNAIL",
};

export const FileTypesAllowed = {
  ImageBasic: "image/jpg, image/jpeg, image/png",
  ImageExtended: "image/gif, image/jpg, image/jpeg, image/png",
  AllImage: "image/*",
  ImageExtendtions: [".jpg", ".jpeg", ".png", ".webp", ".bmp", ".svg"],
  ImageExtendtionsInput: "image/*,.jpg,.jpeg,.png,.webp,.bmp,.svg",
  DocumentBasic: ".pdf, .doc, .docx, .xls, .xlsx, .png",
  VideoAll: "video/*",
  VideoMP4: "video/mp4",
  AudioVideoBasic: ".mp4, .mp3, .mkv, .avi",
  Media: "video/*,audio/*",
  Certificates: [".pdf", ".jpg", ".jpeg", ".png"],
  CertificateInput: "application/pdf,image/jpeg,image/jpg,image/png,.pdf,.jpg,.jpeg,.png",
};

export const UploadFileStates = {
  UPLOADING: "UPLOADING",
  UPLOADED: "UPLOADED",
  ERROR: "ERROR",
};

export const UploadFileIcons = {
  PDF: "/pdf.svg",
  PNG: "/png.svg",
  XLS: "/xls.svg",
};

export const FILE_CONSTANT = {
  MAX_SIZE: 5242880
}